<template>
  <div>
    <!--添加APP-->
    <div class="add-app">
      <div style="position: absolute;left: 16px;top: 17px;font-weight: bolder">应用管理</div>
      <div style="position: absolute;right: 16px;top: 8px" v-if="isAppAdmin">
        <el-button type="primary" @click="addAppDialogVisible = true">添加应用</el-button>
      </div>
    </div>

    <!--添加APP的对话框-->
    <el-dialog title="添加应用" :visible.sync="addAppDialogVisible" :close-on-click-modal="false">
      <el-form :model="form" :rules="this.appInfoRules" ref="createAppInfoForm">
        <el-form-item label="应用名称" prop="appName">
          <el-input v-model="form.appName"></el-input>
        </el-form-item>
        <el-form-item label="应用描述" prop="appDescribe">
          <el-input v-model="form.appDescribe" type="textarea" :rows="5" maxlength="80" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAppDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createApp('createAppInfoForm')">确 定</el-button>
      </div>
    </el-dialog>

    <div class="app-container" v-if="isAppAdmin">
      <h3>我创建的应用</h3>

      <div class="no-app" v-if="adminAppInfos.length === 0">
        <el-image :src="image.noApp"></el-image>
        <p>暂无应用，请点击右上角【添加应用】</p>
      </div>

      <div v-if="adminAppInfos.length > 0" class="card-container">
        <AppInfoCard
            class="app-card"
            v-for="value in adminAppInfos"
            :key="value.appName"
            :appId="value.appId"
            :appName="value.appName"
            :appDescribe="value.appDescribe"
            :is-owner="true"
            v-on:reload-info="loadAllAdminAppInfos">
        </AppInfoCard>
      </div>
    </div>

    <div class="app-container">
      <h3>我的应用</h3>

      <div class="no-app" v-if="userAppInfos.length === 0">
        <el-image :src="image.noApp"></el-image>
        <p>暂无应用，请和应用管理员申请加入应用</p>
      </div>

      <div v-if="userAppInfos.length > 0" class="card-container">
        <AppInfoCard
            class="app-card"
            v-for="value in userAppInfos"
            :key="value.appName"
            :appId="value.appId"
            :appName="value.appName"
            :appDescribe="value.appDescribe"
            :is-owner="false"
            v-on:reload-info="loadAllUserAppInfos">
        </AppInfoCard>
      </div>
    </div>
  </div>
</template>

<script>
import {findAllAdminAppInfos, createAppInfo, findAllUserAppInfos} from "@/api/AppInfo";
import AppInfoCard from "@/views/app/appList/AppInfoCard";
import {appInfoRules} from "@/utils/common"
import {Message} from "element-ui";

function AppInfo(id, appName, appDescribe) {
  this.appId = id
  this.appName = appName
  this.appDescribe = appDescribe
}

export default {
  name: "AppList",
  components: {AppInfoCard},
  mounted() {
    if (this.$store.state.user.isAppAdmin) {
      this.loadAllAdminAppInfos()
    }
    this.loadAllUserAppInfos()
  },
  data() {
    return {
      image: {
        noApp: require('@/assets/应用空.png')
      },
      addAppDialogVisible: false,
      form: {
        appName: undefined,
        appDescribe: undefined
      },
      adminAppInfos: [],
      userAppInfos: [],
      appInfoRules: appInfoRules
    }
  },
  methods: {
    loadAllAdminAppInfos() {
      findAllAdminAppInfos().then((res) => {
        this.adminAppInfos = []
        res.data.forEach(e => {
          let appInfo = new AppInfo(e.id, e.appName, e.appDescription)
          this.adminAppInfos.push(appInfo);
        })
      })
    },
    loadAllUserAppInfos() {
      findAllUserAppInfos().then(res => {
        this.userAppInfos = []
        res.data.forEach(e => {
          let appInfo = new AppInfo(e.id, e.appName, e.appDescription)
          this.userAppInfos.push(appInfo);
        })
      })
    },
    createApp(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          createAppInfo(this.form.appName, this.form.appDescribe).then(() => {
            Message({
              message: "添加应用成功",
              type: "success".duration,
              duration: 3 * 1000
            })
            this.loadAllAdminAppInfos();
            this.addAppDialogVisible = false;
          }).catch(() => {
            this.addAppDialogVisible = false;
          })
        } else {
          return false;
        }
      });
    }
  },
  computed: {
    isAppAdmin() {
      return this.$store.state.user.isAppAdmin
    }
  }
}
</script>

<style scoped>
.add-app {
  width: 100%;
  height: 56px;
  background: #f4f9ff;
}

.no-app {
  width: 100%;
  margin-top: 30px;
  text-align: center;
  color: #666666;
}

.app-container {
  padding: 12px 16px
}

.app-container > h3 {
  border-bottom: #bababa 2px solid;
  padding-bottom: 5px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;

}

.app-card {
  margin-right: 16px;
  margin-bottom: 16px;
}


</style>
